var $348051b3267461b4$exports = {};
$348051b3267461b4$exports = {
    "endTime": `Godzina ko\u{144}cowa`,
    "startTime": `Godzina pocz\u{105}tkowa`,
    "time": `Godzina`
};


export {$348051b3267461b4$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
